import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Box,
    Alert,
    Stack
} from "@mui/material";

export default function PreviewDialog({ open, onClose, url, mime, name, error }) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
            <DialogTitle>{name || "Aperçu du document"}</DialogTitle>
            <DialogContent dividers sx={{ p: 0 }}>
                {error ? (
                    <Box sx={{ p: 3 }}><Alert severity="error">{error}</Alert></Box>
                ) : mime?.includes("pdf") ? (
                    <iframe title="aperçu-pdf" src={url} style={{ width: "100%", height: "80vh", border: "none" }} />
                ) : mime?.startsWith("image/") ? (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
                        <img src={url} alt="aperçu" style={{ maxWidth: "100%", maxHeight: "80vh" }} />
                    </Box>
                ) : (
                    <Box sx={{ p: 3 }}>
                        <Alert severity="info" sx={{ mb: 2 }}>
                            Format non prévisualisable directement ({mime || "inconnu"}).
                        </Alert>
                        <Stack direction="row" spacing={1}>
                            <Button
                                variant="contained"
                                onClick={() => {
                                    const a = document.createElement("a");
                                    a.href = url;
                                    a.download = name || "document";
                                    document.body.appendChild(a);
                                    a.click();
                                    document.body.removeChild(a);
                                }}
                            >
                                Télécharger
                            </Button>
                            <Button variant="outlined" onClick={() => window.open(url, "_blank")}>
                                Ouvrir dans un nouvel onglet
                            </Button>
                        </Stack>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fermer</Button>
            </DialogActions>
        </Dialog>
    );
}
